import React from 'react';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loadingGif from '../../assets/gifs/loading.gif';

const Loader = (props) => {
    return (
        <React.Fragment>
            <div style={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'transparent',
                zIndex: 9999
            }}>
                <img
                    src={loadingGif}
                    alt="Carregando..."
                    style={{ width: 96, height: 96, imageRendering: 'crisp-edges' }}
                />
            </div>
           
            {toast.error(props.error, { position: "top-right", hideProgressBar: false, progress: undefined, toastId: "" })}
        </React.Fragment>
    );
};

export default Loader;

